import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";

import {
  ProjectCard,
  ProjectCardAmount,
  ProjectCardAvatar,
  ProjectCardBadges,
  ProjectCardClubAvatar,
  ProjectCardContent,
  ProjectCardCover,
  ProjectCardDescription,
  ProjectCardFooter,
  ProjectCardHeader,
  ProjectCardImage,
  ProjectCardImageFallback,
  ProjectCardLabel,
  ProjectCardPercentage,
  ProjectCardStatusBadge,
  ProjectCardTaxBadge,
} from "../../../../shared-external/components/project-card/project-card";

const FeaturedShortProjectCard = ({
  project,
  className,
}: {
  project: Project;
  className?: string;
}) => {
  return (
    <ProjectCard
      project={project}
      className={cn(
        "h-[320px] !min-w-[208px] max-w-[312px] hover:bg-white hover:shadow-none lg:min-w-[208px]",
        className,
      )}
    >
      <ProjectCardCover>
        <ProjectCardImage className="h-[165px]" />
        <ProjectCardImageFallback className="h-[165px]" />
        <ProjectCardTaxBadge className="h-4 p-[5px] text-[8px]" />
        <ProjectCardStatusBadge className="h-4 p-[5px] text-[8px]" />
        <ProjectCardClubAvatar />
      </ProjectCardCover>
      <ProjectCardContent className="p-4">
        <ProjectCardHeader className="mb-[5px]">
          <ProjectCardAvatar />
          <ProjectCardLabel className="text-base" />
        </ProjectCardHeader>
        <ProjectCardBadges
          className="mb-2.5"
          badgeClassName="h-4 p-[5px] text-[8px]"
        />
        <ProjectCardDescription className="line-clamp-2 h-auto text-[9px]" />
        <ProjectCardFooter>
          <ProjectCardAmount className="whitespace-nowrap text-[9px]" />
          <ProjectCardPercentage className="h-auto p-[5px] text-[8px]" />
        </ProjectCardFooter>
      </ProjectCardContent>
    </ProjectCard>
  );
};

const FeaturedMediumProjectCard = ({
  project,
  className,
}: {
  project: Project;
  className?: string;
}) => {
  return (
    <ProjectCard
      project={project}
      className={cn(
        "min-w-[312px] hover:bg-white hover:shadow-none lg:min-w-[312px] lg:max-w-[312px]",
        className,
      )}
    >
      <ProjectCardCover>
        <ProjectCardImage className="h-[199px]" />
        <ProjectCardImageFallback className="h-[199px]" />
        <ProjectCardTaxBadge className="h-[22px] p-[7px] text-[10px]" />
        <ProjectCardStatusBadge className="h-[22px] p-[7px] text-[10px]" />
        <ProjectCardClubAvatar />
      </ProjectCardCover>
      <ProjectCardContent className="p-[21px]">
        <ProjectCardHeader className="mb-[7px]">
          <ProjectCardAvatar />
          <ProjectCardLabel />
        </ProjectCardHeader>
        <ProjectCardBadges
          className="mb-3.5"
          badgeClassName="h-[22px] p-[7px] text-[10px]"
        />
        <ProjectCardDescription />
        <ProjectCardFooter>
          <ProjectCardAmount className="whitespace-nowrap" />
          <ProjectCardPercentage className="h-auto p-[5px] text-xs" />
        </ProjectCardFooter>
      </ProjectCardContent>
    </ProjectCard>
  );
};

export { FeaturedShortProjectCard, FeaturedMediumProjectCard };
